import { Component, OnInit } from '@angular/core';
// import * as PDFJS from 'pdfjs-dist';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss']
})
export class TermsDialogComponent implements OnInit {
  title = 'app';

  // pdfurl = this.web() > 0 ? './assets/nzconditions.pdf' : './assets/auconditions.pdf';

  pdfurl = '';
  pdfDoc = null;
  pageNum = 1;
  pageRendering = false;
  pageNumPending = null;
  scale = 1.5;
  canvas: any;
  ctx: any;

  web() {
    // console.log(window.location.href.indexOf(".co.nz"));
    return window.location.href.indexOf('.co.nz');
    // return 1;
  }

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';

  }

  // loadPDF() {
  //   const loadingTask = PDFJS.getDocument(this.pdfurl);
  //   console.log('get the pdf js: ', loadingTask);

  //   this.canvas = <HTMLCanvasElement>document.getElementById('the-canvas');
  //   this.ctx = this.canvas.getContext('2d');

  //   loadingTask.then(pdfDoc_ => {
  //     this.pdfDoc = pdfDoc_;
  //     // document.getElementById('page_count').textContent = this.pdfDoc.numPages;

  //     // Initial/first page rendering
  //     this.renderPage(this.pageNum);
  //   });
  // }

  preventClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  queueRenderPage(num) {
    if (this.pageRendering) {
      this.pageNumPending = num;
    } else {
      this.renderPage(num);
    }
  }

  previous() {
    if (this.pageNum <= 1) {
      return;
    }
    this.pageNum--;
    this.queueRenderPage(this.pageNum);
  }
  next() {
    if (this.pageNum >= this.pdfDoc.numPages) {
      return;
    }
    this.pageNum++;
    this.queueRenderPage(this.pageNum);
  }

  renderPage(num) {
    this.pageRendering = true;
    // Using promise to fetch the page
    this.pdfDoc.getPage(num).then(page => {
      // tslint:disable-next-line:prefer-const
      let viewport = page.getViewport(this.scale);
      this.canvas.height = viewport.height;
      this.canvas.width = viewport.width;

      // Render PDF page into canvas context
      // tslint:disable-next-line:prefer-const
      let renderContext = {
        canvasContext: this.ctx,
        viewport: viewport
      };
      // tslint:disable-next-line:prefer-const
      let renderTask = page.render(renderContext);

      // Wait for rendering to finish
      renderTask.promise.then(() => {
        this.pageRendering = false;
        if (this.pageNumPending !== null) {
          // New page rendering is pending
          this.renderPage(this.pageNumPending);
          this.pageNumPending = null;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/register/terms-dialog/terms-dialog.component.ts